import { FundingPolicyType } from '@shared';

export function getAiPromptTypeByPolicyType(formData?: PolicyFormSubmissionData): string {
  const policyType = formData?.policyType;

  switch (policyType) {
    case FundingPolicyType.careMattersTwo:
      return 'underwriting-nw-guidance';
    case FundingPolicyType.jointCareMatters:
      return 'underwriting-nw-partner-guidance';
    case FundingPolicyType.assetCare:
      return 'underwriting-oa-guidance';
    case FundingPolicyType.jointAssetCare:
      return 'underwriting-oa-partner-guidance';
    case FundingPolicyType.careScoutCareAssurance:
      return 'underwriting-cs-guidance';
    case FundingPolicyType.moneyGuardFixedAdvantage:
      return 'underwriting-lincoln-guidance';
    case FundingPolicyType.secureCareThree:
      return 'underwriting-securian-guidance';
    default:
      return 'underwriting-nw-guidance';
  }
}
